export default __webpack_public_path__ + "static/media/item_5@2x.9ed0e163.png";